import { AuthStorage } from "utils/auth-storage";
import { ActiveUsersService } from "apis/Services/ActiveUsersService";
import { Avatar, Tooltip } from "antd";
import React, { useEffect, useRef, useState } from "react";

const COLORS = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae", "#e6475a"];

// Builds initials for the active-user avatar stack.
function getInitials(pair) {
  return pair.map((name) => name.charAt(0).toUpperCase()).join("");
}

// Tracks and renders the users currently active in the procurement log.
function ProcurementActiveUsers({ company_id, project_id }) {
  const COLORS = [
    "linear-gradient(135deg, #f56a00, #f9a825)",
    "linear-gradient(135deg, #7265e6, #b39ddb)",
    "linear-gradient(135deg, #00a2ae, #00bcd4)",
    "linear-gradient(135deg, #e6475a, #f48fb1)",
    "linear-gradient(135deg, #43a047, #a5d6a7)",
  ];

  const [ActiveUsers, setActiveUsers] = useState([]);
  const [ActiveUsersIcon, setActiveUsersIcon] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const inactivityTimeoutRef = useRef(null);

  // Refreshes the active-user list for the current project.
  const getActiveUsers = (data) => {
    ActiveUsersService.getUsers(data)
      .then((res) => {
        setActiveUsers(res);
        setActiveUsersIcon(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Registers the current user as active when they open the page.
  const addUser = async () => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = { company_id, loginEmail, code, project_id };
    await ActiveUsersService.AddUser(data)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setTimeout(() => {
          getActiveUsers(data);
        }, 500);
      });
  };

  // Removes the current user from the active list when they leave or go idle.
  const removeUser = () => {
    let code = AuthStorage.getItem("token");
    let loginEmail = AuthStorage.getItem("email");
    let data = { company_id, loginEmail, code, project_id };
    ActiveUsersService.RemoveUser(data)
      .then(() => {})
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setTimeout(() => {
      addUser();
    }, 200);
    return () => {
      removeUser();
    };
  }, []);

  useEffect(() => {
    // Resets the inactivity timer that clears inactive users from the page.
    const resetInactivityTimeout = () => {
      clearTimeout(inactivityTimeoutRef.current);
      inactivityTimeoutRef.current = setTimeout(
        () => {
          let code = AuthStorage.getItem("token");
          let loginEmail = AuthStorage.getItem("email");
          let data = { company_id, loginEmail, code, project_id };
          ActiveUsersService.RemoveUser(data)
            .then(() => {})
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              setTimeout(() => {
                getActiveUsers(data);
              }, 200);
            });
        },
        2 * 60 * 60 * 1000,
      );
    };

    // Keeps the current user marked active while they interact with the page.
    const handleUserActivity = () => resetInactivityTimeout();

    // Removes the current user immediately when the tab is about to close.
    const handleTabClose = () => {
      let code = AuthStorage.getItem("token");
      let loginEmail = AuthStorage.getItem("email");
      let data = { company_id, loginEmail, code, project_id };
      ActiveUsersService.RemoveUser(data)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    };

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);
    window.addEventListener("beforeunload", handleTabClose);
    resetInactivityTimeout();
    setInitialized(true);

    return () => {
      clearTimeout(inactivityTimeoutRef.current);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, [initialized]);

  if (!ActiveUsersIcon?.length) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: "#f5f6fa",
        border: "1px solid #ebebeb",
        borderRadius: "999px",
        padding: "4px 12px 4px 10px",
      }}
    >
      <span
        style={{
          // fontSize: "14px",
          fontWeight: 500,
          color: "#888",
          whiteSpace: "nowrap",
        }}
      >
        Active
      </span>
      <Avatar.Group
        size="default"
        max={{
          count: 5,
          style: {
            backgroundColor: "#fde3cf",
            color: "#f56a00",
          },
        }}
      >
        {ActiveUsersIcon.map((pair, index) => (
          <Tooltip key={index} title={pair.join(" ")} placement="bottom">
            <Avatar
              style={{
                background: COLORS[index % COLORS.length],
              }}
              size="default"
            >
              {getInitials(pair)}
            </Avatar>
          </Tooltip>
        ))}
      </Avatar.Group>
    </div>
  );
}

export default ProcurementActiveUsers;
